import { render } from "./xtx-dialog.vue?vue&type=template&id=50a326dc&scoped=true"
import script from "./xtx-dialog.vue?vue&type=script&lang=js"
export * from "./xtx-dialog.vue?vue&type=script&lang=js"

import "./xtx-dialog.vue?vue&type=style&index=0&id=50a326dc&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a326dc"]])

export default __exports__